import { FloorSize } from '../types/floorplan';
import { isNil, some } from 'lodash';
var personSitsOnThisTable = function (person, floor, space, table) {
    return (person.floor &&
        person.floor.title === floor.title &&
        person.space &&
        person.space.title === space.title &&
        person.table &&
        person.table.letter === table.letter);
};
var someoneSitsOnThisTable = function (owners, floor, space, table) {
    return some(owners, function (owner) { return personSitsOnThisTable(owner, floor, space, table); });
};
var SpacesStore = /** @class */ (function () {
    function SpacesStore(floorPlanStore) {
        this.floorPlanStore = floorPlanStore;
    }
    // --------------------------------------------------------------------------
    SpacesStore.prototype.spaceOptionsOnAFloor = function (floor, includeEmpty) {
        if (includeEmpty === void 0) { includeEmpty = false; }
        var spaceTitles = floor.spaces.map(function (space) { return space.title; });
        var allTitles = includeEmpty ? ['-'].concat(spaceTitles) : spaceTitles;
        return allTitles.map(function (title) {
            return ({
                value: title,
                label: title,
                disabled: false,
            });
        });
    };
    SpacesStore.prototype.tableOptionsOnASpace = function (floor, space, includeEmpty, disableReserved) {
        if (includeEmpty === void 0) { includeEmpty = false; }
        if (disableReserved === void 0) { disableReserved = false; }
        var assignedOwners = this.floorPlanStore.assignedOwners;
        var tables = space.tables;
        var tableOptions = tables.map(function (table) {
            return ({
                value: table.letter,
                label: table.letter,
                disabled: disableReserved && someoneSitsOnThisTable(assignedOwners, floor, space, table),
            });
        });
        var emptyOptions = [
            {
                value: '-',
                label: '-',
                disabled: false,
            },
        ];
        return includeEmpty ? emptyOptions.concat(tableOptions) : tableOptions;
    };
    SpacesStore.prototype.suggestSpaceNumber = function (floor) {
        var reservedNumbers = floor.spaces
            .map(function (space) { return parseInt(space.title, 10); })
            .filter(function (spaceNumber) { return !isNil(spaceNumber); });
        if (reservedNumbers.length === 0) {
            // add initial suggestions based on the floor size
            var floorSize = floor.floorSize === FloorSize.SMALL ? 100 : 1000;
            var initialSpaceSuggestion = parseInt(floor.title, 10) * floorSize;
            reservedNumbers.push(initialSpaceSuggestion);
        }
        return Math.max.apply(Math, reservedNumbers) + 1;
    };
    SpacesStore.prototype.suggestTableLetter = function (tables) {
        var reservedLetters = tables
            .map(function (t) { return t.letter.toUpperCase(); })
            .filter(function (l) { return l.length === 1; })
            .map(function (letter) { return letter.replace(/[^A-ZÆØÅ]/, ''); })
            .filter(function (l) { return l.length === 1; })
            .sort(function (a, b) { return a.charCodeAt(0) - b.charCodeAt(0); });
        if (reservedLetters.length === 0) {
            return 'A';
        }
        var lastLetter = reservedLetters[reservedLetters.length - 1];
        switch (lastLetter) {
            case 'Z':
                return 'Æ';
            case 'Æ':
                return 'Ø';
            case 'Ø':
                return 'Å';
            case 'Å':
                return '';
            default:
                return String.fromCharCode(lastLetter.charCodeAt(0) + 1);
        }
    };
    return SpacesStore;
}());
export { SpacesStore };
//# sourceMappingURL=spaces.js.map